import React, { Component } from 'react';
import Sidebar from '../sidebar/sidebar';
import Employee from '../employee/employee';
import { connect } from 'react-redux';

import get from 'lodash.get';
import has from 'lodash.has';

import './employees.css';
import {Helmet} from "react-helmet";

class Employees extends Component {

    componentDidMount() {
        window.scrollTo(0,0);
    }

    constructor(props) {
        super(props);
        this.onEmployeeTrigger = this.onEmployeeTrigger.bind(this);

        this.state = {
            triggeredEmployee: null
        };
    }

    onEmployeeTrigger(employee) {
        if (this.state.triggeredEmployee === employee.id) {
            this.setState({triggeredEmployee: null});
        } else {
            if (window && window.fathom) {
                window.fathom.trackPageview({
                    url: '/de-mensen-van-kwoot/' + employee.slug
                });
            }
            this.setState({triggeredEmployee: employee.id});
        }
    }

    render() {
        return (
            <div className="employees">
                <Helmet>
                    <title>Wie we zijn - KWOOT</title>
                    <meta property="og:title" content={"Wie we zijn - KWOOT"} />
                </Helmet>
                <Sidebar title="Wie we zijn" description={ get(this.props, 'postOptions.sidebar_description', '') } image={get(this.props, 'postOptions.sidebar_afbeelding.sizes.large','')}/>
                <div className="employees__content">
                    {
                        this.props.employees.map((employee, index) => {
                            let triggeredEmployee = (this.state.triggeredEmployee === employee.id);

                            return (
                                <Employee key={employee.id} employee={employee} triggered={triggeredEmployee} onEmployeeTrigger={this.onEmployeeTrigger}/>
                            )
                        })
                    }
                </div>
                <div></div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {

    let employees = [];
    let postOptions = {};

    if (store.employees && store.employees.employees) {
        employees = store.employees.employees;
    }

    if (has(store, 'site.options.posttype.employee')) {
        postOptions = get(store, 'site.options.posttype.employee');
    }

    return {
        employees: employees,
        postOptions: postOptions
    }
}

export default connect(mapStateToProps)(Employees);



// WEBPACK FOOTER //
// ./src/components/employees/employees.js